/*
  CALL SP下部ナビ。やることは4つだけ。
  1. 選択中タブへ白玉を移す
  2. 下スクロールで退避 / 上スクロールで戻す
  3. ヘッダーのカート件数・新着ドットをナビへ同期する(数の正は既存のヘッダー側)
  4. どのタブが押されたかを計測する(2026-10-19)
*/
(function () {
  'use strict';

  var nav = document.querySelector('[data-cec-bn]');
  if (!nav) return;

  document.body.classList.add('cec-has-bottomnav');
  /* ヘッダーのハンバーガー/カートを隠すかは設定から */
  if (nav.getAttribute('data-hide-hmenu') === 'true') document.body.classList.add('cec-hide-hmenu');
  if (nav.getAttribute('data-hide-hcart') === 'true') document.body.classList.add('cec-hide-hcart');

  /* 指やマウスで開いた時に枠を出さない。
     ドロワーを閉じるとテーマが「開いたタブ」へフォーカスを戻すので、
     そのままだとブラウザが :focus-visible と判定して黒い枠が残る。
     キーボード操作(Tab)の時は枠を出したいので、直前の操作の種類で切り替える。 */
  var root = document.documentElement;
  document.addEventListener(
    'pointerdown',
    function () {
      root.setAttribute('data-cec-pointer', '');
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Tab') root.removeAttribute('data-cec-pointer');
    },
    true
  );

  var items = Array.prototype.slice.call(nav.querySelectorAll('.cec-bn__item'));
  var pill = nav.querySelector('.cec-bn__pill');

  /* ---- 4. 計測 ----
     カスタムピクセル callec-collection-events が GA4 へ送る(イベント名 bn_tab_click)。
     ドロワーを開くタブも含め、押された時点で1回送る */
  items.forEach(function (el, idx) {
    el.addEventListener('click', function () {
      try {
        if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
        var t = document.body.className.match(/template-[\w-]+/);
        var label = el.querySelector('.cec-bn__label');
        Shopify.analytics.publish('callec:bn_tab_click', {
          tab: label ? label.textContent.trim() : '',
          action: el.getAttribute('data-cec-action') || '',
          position: idx + 1,
          template: t ? t[0] : ''
        });
      } catch (err) {
        // 計測の失敗で操作を止めない
      }
    });
  });

  /* ---- 1. 白玉の位置 ---- */
  function placePill() {
    if (!pill) return;
    var i = -1;
    items.forEach(function (el, idx) {
      if (el.getAttribute('aria-current') === 'page') i = idx;
    });
    if (i < 0) {
      pill.classList.remove('is-on');
      return;
    }
    pill.style.transform = 'translateX(calc(' + i + ' * (100% + 8px) + 4px))';
    pill.classList.add('is-on');
  }
  placePill();

  /* ---- 2. スクロール時の挙動 ----
     data-scroll: "shrink"(少し縮む・既定) / "hide"(画面外へ) / "none"(何もしない) */
  var mode = nav.getAttribute('data-scroll') || 'shrink';
  var AWAY = mode === 'hide' ? 'is-hidden' : 'is-compact';
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  var THRESHOLD = 80;
  /* 2026-09-04 ブルブル対策: 指の微妙な戻りや端のバウンスで向きが反転するたびに
     切り替わるとロゴのアニメーションが何度も走り直す。同じ向きに 28px 進んで初めて
     切り替え、切り替え直後 350ms は再切替しない。ページ端(ラバーバンド)は無視する */
  var SWITCH_PX = 28;
  var LOCK_MS = 350;
  var acc = 0;
  var lockUntil = 0;
  var away = false;

  function setAway(v) {
    if (away === v) return;
    away = v;
    nav.classList.toggle(AWAY, v);
    /* 周辺要素(TOPに戻る)がナビの縮みに追随できるよう body にも写す */
    document.body.classList.toggle('cec-bn-compact', v && AWAY === 'is-compact');
    lockUntil = Date.now() + LOCK_MS;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = Math.min(Math.max(window.pageYOffset || 0, 0), max);
      var dy = y - lastY;
      lastY = y;

      if (y < THRESHOLD) {
        acc = 0;
        setAway(false);
      } else if (Date.now() >= lockUntil) {
        /* 向きが変わったら積算をやり直す */
        if ((dy > 0 && acc < 0) || (dy < 0 && acc > 0)) acc = 0;
        acc += dy;
        if (acc > SWITCH_PX) {
          setAway(true);
          acc = 0;
        } else if (acc < -SWITCH_PX) {
          setAway(false);
          acc = 0;
        }
      }
      ticking = false;
    });
  }
  if (mode !== 'none') {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- 3. ヘッダーからの同期 ---- */
  var badge = nav.querySelector('[data-cec-bn-cart]');
  var headerCount = document.querySelector('[data-cart-count-number]');

  function syncCart() {
    if (!badge) return;
    var n = 0;
    if (headerCount) {
      n = parseInt((headerCount.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
    }
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n <= 0;
  }
  syncCart();

  if (headerCount && window.MutationObserver) {
    new MutationObserver(syncCart).observe(headerCount, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  document.addEventListener('cart:updated', syncCart);
  document.addEventListener('cart:refresh', syncCart);

  var navDot = nav.querySelector('[data-cec-bn-dot]');
  var headerDot = document.querySelector('[data-cec-menu-dot]');

  function syncDot() {
    if (!navDot) return;
    navDot.hidden = !headerDot || headerDot.hidden;
  }
  syncDot();

  if (headerDot && window.MutationObserver) {
    new MutationObserver(syncDot).observe(headerDot, {
      attributes: true,
      attributeFilter: ['hidden']
    });
  }

  /* テーマプレビュー中だけ出る Shopify のバー(#PBarNextFrameWrapper)の分を持ち上げる。
     本番には存在しないので 0 のまま。 */
  function liftForPreviewBar() {
    var pb = document.getElementById('PBarNextFrameWrapper');
    var h = pb ? Math.round(pb.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--cec-bn-pb', h + 'px');
  }
  liftForPreviewBar();
  window.setTimeout(liftForPreviewBar, 1500);

  window.addEventListener('resize', function () {
    placePill();
    liftForPreviewBar();
  });
})();
